import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import CollectionList from './CollectionList';
import CollectionListContainer from './CollectionList.container';
import CollectionListBranched from '../CollectionList.add_to_faves_2/';
export default withFeatureBranch({
    add_to_faves_2: CollectionListBranched,
})(CollectionListContainer(CollectionList));
//# sourceMappingURL=index.js.map